<template>
  <error :loadTheme="false">
    <template #message>
      <section class="is-flex is-flex-direction-column">
        <span class="is-size-5"
              data-unit="widget-content-error-page-title">
          {{ errorMessage }}
        </span>
      </section>
    </template>
  </error>
</template>

<script>
import Error from "@/components/Error"
import { WidgetEventErrors } from '@/interfaces/global/widgets'

export default {
  name: "WidgetContentError",
  components: { Error },
  props: {
    errorType: {
      type: String,
      default: null
    }
  },
  computed: {
    errorMessage() {
      const errorTypeToI18nKey = {
        [WidgetEventErrors.config]: 'widgetErrorConfig',
        [WidgetEventErrors.init]: 'widgetErrorInit',
        [WidgetEventErrors.location]: 'widgetErrorLocation',
        [WidgetEventErrors.multiple_locations]: 'widgetErrorMultipleLocations',
        [WidgetEventErrors.content_not_found]: 'contentNotFound'
      }
      const i18nKey = errorTypeToI18nKey[this.errorType] || 'contentNotFound'
      return this.$t(i18nKey)
    }
  }
}
</script>
